import { HiChevronRight } from "react-icons/hi2";
import { useAuth } from "../../../core/auth";
import { useNavigate } from "react-router-dom";

interface StoreTitleProps {
  title?: string;
}

const StoreTitle = ({ title }: StoreTitleProps) => {
  const { isManagerLoggedIn } = useAuth();
  const navigate = useNavigate();
  // 매니저가 로그인했을 때만 매장 제목을 표시
  if (!isManagerLoggedIn || !title) {
    return null;
  }

  return (
    <div
      onClick={() => navigate(`/manager/home`)}
      className="bg-blue-600 text-white py-2 px-4 text-center font-semibold shadow-sm flex items-center gap-1 justify-center"
    >
      <span className="text-sm">현재 접속 매장:</span>{" "}
      <span className="font-bold underline">{title}</span>{" "}
      <HiChevronRight className="w-3.5 h-3.5" />
    </div>
  );
};

export default StoreTitle;
